<div class="directory-page">
  <div class="header-section">
    <h1 class="page-title">{{('directory-page.title' | translate: {title: (pageConfig.title | translate)}) }}</h1>
    <p class="other-directories">{{'directory-page.cant-find' | translate}}
      <a [routerLink]="pageConfig.sublink1.url">
        {{('directory-page.title' | translate: {title: (pageConfig.sublink1.title | translate)}) }},
      </a>
      <a [routerLink]="pageConfig.sublink2.url">
        {{('directory-page.title' | translate: {title: (pageConfig.sublink2.title | translate)}) }}
      </a>
      {{'directory-page.or' | translate}} 
      <a [routerLink]="pageConfig.sublink3.url">
          {{('directory-page.title' | translate: {title: (pageConfig.sublink3.title | translate)}) }}
        </a>
    </p>
  </div>
  <div class="directories-container">
    <p class="search-text">{{('directory-page.search-by-location' | translate: {title: (pageConfig.title | translate | lowercase)})}}</p>
    <div class="province-container" *ngFor="let link of directoryLinks">
      <div class="province-header" (click)="link.visible=!link.visible">
        <p class="province-title">{{ link?.province | translate}}</p>
        <span class="material-icons">{{!link?.visible ? 'add' : 'remove'}}</span>
      </div>
      <div class="directory-container" *ngIf="link.visible && link.cityCardLinks">
        <div class="card-container" *ngFor="let city of link.cityCardLinks | slice:0:10">
          <app-link-card [cardLink]="city"></app-link-card>
        </div>
        <div class="card-container" [class.mobile-hidden]="!link.showMore" *ngFor="let city of link.cityCardLinks | slice:10">
            <app-link-card [cardLink]="city"></app-link-card>
        </div>
        <p class="no-results" *ngIf="link?.cityCardLinks && link?.cityCardLinks.length == 0">
          {{'directory-page.no-results' | translate}}
        </p>
        <button (click)="link.showMore=!link.showMore" class="show-more" *ngIf="link?.cityCardLinks.length > 10" >
          {{ !link.showMore ? ( ('directory-page.show-more' | translate) + ' ('+ (link?.cityCardLinks?.length - 10) +')') : ('directory-page.show-less' | translate)}} 
        </button>
    </div>
    <div class="neighbourhood-container" *ngIf="link.visible && link.listLinks">
      <p class="no-results" *ngIf="link?.listLinks && link?.listLinks.length == 0">
          {{'directory-page.no-results' | translate}}
      </p>
      <div class="neighbourhood-links-container">
        <p class="subheading">{{'directory-page.popular-neighbourhoods' | translate}}</p>
        <div class="links-container">
          <a class="neighbourhood-link" [title]="text?.neighbourhoodName" [routerLink]="text?.detailUrl" *ngFor="let text of link.listLinks | slice:0:50">
            {{text?.neighbourhoodName}}
          </a>
          <a class="neighbourhood-link" [class.mobile-hidden]="link.showMore < 1" [title]="text?.neighbourhoodName" [routerLink]="text?.detailUrl" *ngFor="let text of link.listLinks | slice:50:75">
            {{text?.neighbourhoodName}}
          </a>
          <a class="neighbourhood-link" [class.mobile-hidden]="link.showMore < 2" [title]="text?.neighbourhoodName" [routerLink]="text?.detailUrl" *ngFor="let text of link.listLinks | slice:75">
            {{text?.neighbourhoodName}}
          </a>
        </div>
        <button (click)="link.showMore = updateShownValue(link.showMore)" class="show-more" *ngIf="link?.listLinks.length > 50" >
            {{ ((50 + (25 * link.showMore)) < link.listLinks.length) ? ( ('directory-page.show-more' | translate) + ' (25)') : ('directory-page.show-less' | translate)}} 
        </button>
      </div>
    </div>
  </div>
</div>